// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/time-picker","toggleMenuButton":"time-picker-m__toggleMenuButton__2SXBF button-m__nativeResetRoot__18WbL","popup":"time-picker-m__popup__29KxG"};